<form [formGroup]="form" (ngSubmit)="onFilter(form)">
  <!-- control number -->
  <div class="form-group form-row">
    <label for="input-control-no" class="col-sm-2 col-form-label">Control Number</label>
    <div class="col-sm-10">
      <input type="text" id="input-control-no" class="form-control" formControlName="controlNo">
    </div>
  </div>

  <!-- customer -->
  <div class="form-group form-row">
    <label for="input-customer" class="col-sm-2 col-form-label">Customer</label>
    <div class="col-sm-10">
      <input type="text" id="input-customer" class="form-control" formControlName="customer">
    </div>
  </div>

  <!-- location -->
  <div class="form-group form-row">
    <label for="input-location" class="col-sm-2 col-form-label">Location</label>
    <div class="col-sm-10">
      <input type="text" id="input-location" class="form-control" formControlName="location">
    </div>
  </div>

  <div class="form-group form-row">
    <label for="input-start-datetime" class="col-sm-2 col-form-label">Task Plan Starts From</label>
    <div class="col-sm-10">
      <input type="datetime-local" id="input-start-datetime" class="form-control" formControlName="startDatetime" aria-describedby="start-datetime">
      <small id="start-datetime" class="form-text text-muted">
        Please enter the date and time relative to the Australia/Melbourne timezone.
      </small>
    </div>
  </div>

  <fieldset class="form-group" formGroupName="actions">
    <div class="form-row">
      <!-- task action selection -->
      <legend class="col-form-label col-sm-2 pt-0">Task Action</legend>

      <div class="col-sm-10">
        <div class="form-row">
          <!-- Pickup action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-pickup" class="form-check-input" formControlName="pickup">
              <label for="input-action-pickup" class="form-check-label">Pickup</label>
            </div>
          </div>
  
          <!-- deliver action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-deliver" class="form-check-input" formControlName="deliver">
              <label for="input-action-deliver" class="form-check-label">Deliver</label>
            </div>
          </div>
  
          <!-- release action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-release" class="form-check-input" formControlName="release">
              <label for="input-action-release" class="form-check-label">Release</label>
            </div>
          </div>
  
          <!-- collect action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-collect" class="form-check-input" formControlName="collect">
              <label for="input-action-collect" class="form-check-label">Collect</label>
            </div>
          </div>
  
          <!-- start action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-start" class="form-check-input" formControlName="start">
              <label for="input-action-start" class="form-check-label">Start</label>
            </div>
          </div>
  
          <!-- end action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-end" class="form-check-input" formControlName="end">
              <label for="input-action-end" class="form-check-label">End</label>
            </div>
          </div>
  
          <!-- breakdown action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-breakdown" class="form-check-input" formControlName="breakdown">
              <label for="input-action-breakdown" class="form-check-label">Breakdown</label>
            </div>
          </div>
  
          <!-- refuel action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-refuel" class="form-check-input" formControlName="refuel">
              <label for="input-action-refuel" class="form-check-label">Refuel</label>
            </div>
          </div>
  
          <!-- trailer release action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-trailer-release" class="form-check-input" formControlName="trailerRelease">
              <label for="input-action-trailer-release" class="form-check-label">Trailer Release</label>
            </div>
          </div>
  
          <!-- trailer collect action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-trailer-collect" class="form-check-input" formControlName="trailerCollect">
              <label for="input-action-trailer-collect" class="form-check-label">Trailer Collect</label>
            </div>
          </div>
  
          <!-- create action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-create" class="form-check-input" formControlName="create">
              <label for="input-action-create" class="form-check-label">Create</label>
            </div>
          </div>
  
          <!-- accept action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-accept" class="form-check-input" formControlName="accept">
              <label for="input-action-accept" class="form-check-label">Accept</label>
            </div>
          </div>
  
          <!-- reject action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-reject" class="form-check-input" formControlName="reject">
              <label for="input-action-reject" class="form-check-label">Reject</label>
            </div>
          </div>
  
          <!-- empty run start action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-empty-run-start" class="form-check-input" formControlName="emptyRunStart">
              <label for="input-action-empty-run-start" class="form-check-label">Empty Run Start</label>
            </div>
          </div>
  
          <!-- empty run end action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-empty-run-end" class="form-check-input" formControlName="emptyRunEnd">
              <label for="input-action-empty-run-end" class="form-check-label">Empty Run End</label>
            </div>
          </div>
  
          <!-- upload paperwork action checkbox -->
          <div class="col-6 col-sm-4 col-md-2">
            <div class="form-check">
              <input type="checkbox" name="task-action" id="input-action-upload-paperwork" class="form-check-input" formControlName="uploadPaperwork">
              <label for="input-action-upload-paperwork" class="form-check-label">Upload Paperwork</label>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-group" formGroupName="statuses">
    <div class="form-row">
      <!-- task status selection -->
      <legend class="col-form-label col-sm-2 pt-0">Task Status</legend>

      <div class="col-sm-10">
        <!-- task not done status checkbox -->
        <div class="form-check">
          <input type="checkbox" name="task-status" id="input-status-not-done" class="form-check-input" formControlName="notDone">
          <label for="input-status-not-done" class="form-check-label">Not Done</label>
        </div>

        <!-- task done status checkbox -->
        <div class="form-check">
          <input type="checkbox" name="task-status" id="input-status-done" class="form-check-input" formControlName="done">
          <label for="input-status-done" class="form-check-label">Done</label>
        </div>
      </div>
    </div>
  </fieldset>

  <div class="d-flex flex-row-reverse">
    <button type="submit" class="btn btn-sm btn-success">Apply Filter</button>
    <button type="button" class="btn btn-sm btn-outline-dark mr-3" (click)="onReset(form)">Reset</button>
  </div>
</form>